import firebase from 'firebase/compat/app';

const config = {
  apiKey: "AIzaSyB7vbcMNnpWyvceCrstfF9GpOinX7YcALc",
  authDomain: "full-crispy.firebaseapp.com",
  projectId: "full-crispy",
  storageBucket: "full-crispy.appspot.com",
  messagingSenderId: "404812984185",
  appId: "1:404812984185:web:03f865db3b17e533a989a8",
  measurementId: "G-E68TC94J30",
}

firebase.initializeApp(config);

export default firebase
